export const DatatypeEnum = {
    'SERIE': 'SERIE',
    'QUESTION': 'QUESTION'
};
